<template>
  <div class="header-wrap">
    <img src="../image/logo.png" alt="" srcset="" class='img-1' @click='index' />
    <div class="right">
      <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" active-text-color="#3D3D3D" menu-trigger="click">
        <el-menu-item index="/functionIntroduce" @click="goFunction">功能介绍</el-menu-item>
        <el-menu-item index="/reportList" @click="goList" v-if="!isShow">任务列表</el-menu-item>
        <el-menu-item index="/dingjia" @click="goAdd" v-if="!isShow">产品定价</el-menu-item>
        <el-menu-item index="/concatUs" @click="goConcat">联系我们</el-menu-item>
        <el-menu-item index="/courses" @click="goCourses">育种课堂</el-menu-item>
      </el-menu>
      <div class="btn-wrap" v-if="isShow">
        <div @click="login" v-if="!$route.meta.isLogin" class="right-login">登陆</div>
        <div @click="register" v-if="!$route.meta.isReguser" class="right-reguser">注册</div>
      </div>
      <div class="btn-wrap" v-else>
        <el-dropdown v-if="role === 'ADMIN'">
          <span class="user">
            管理员｜{{ userName }}
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="loginout">退出登陆</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-dropdown v-else>
          <span class="user">
            <img src="../images/frontPage/vips.png" alt="" class="vip-img">
            {{ userName }}
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="goUserInfo" class="dropdown-item">用户中心</el-dropdown-item>
              <el-dropdown-item @click="goProblem" class="dropdown-item">任务列表</el-dropdown-item>
              <el-dropdown-item @click="loginout" class="dropdown-item">退出登陆</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>


      </div>
    </div>
  </div>
</template>

<script>
import { post, REQUEST_API } from "@/request/http.js";
import { clearUserInfo } from '@/tools'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Header',
  data() {
    return {
      isShow: false,
      activeIndex: '-1',
      activeIndex2: '1',
      userName: '',
      role: ''
    }
  },
  props: {
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.isShow = false
    } else {
      this.isShow = true
    }
    if (localStorage.getItem('userName')) {
      this.userName = localStorage.getItem('userName')
    }
    if (localStorage.getItem('role')) {
      this.role = localStorage.getItem('role')
    }
  },
  methods: {
    login() {
      this.$router.push('/login')
    },
    index() {
      this.$router.push('/')
    },
    goProblem() {
      this.$router.push('/reportList')
    },
    goApplication() {
      this.$router.push('/billApplication')
    },
    goPay() {
      this.$router.push('/pay')
    },
    register() {
      this.$router.push('/reguser')
    },
    goMy(){
      this.$router.push('/userReview')
    },
    goConcat(){
      this.$router.push('/problemHelp')
    },
    goCourses(){
      window.location.href='/static/courses.html'
    },
    goList(){
      this.$router.push('/reportList')
    },
    loginout() {
      post(`${REQUEST_API}/user/logout`).then(res => {
        if (res.code === 200) {
          this.$message.success('退出登陆成功')
          clearUserInfo()
          this.$router.push('/login')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    goAdd() {
      this.activeIndex = '1'
      if (this.isShow) {
        this.$router.push('/reguser')
      } else {
        this.$router.push('/dingjia')
      }
    },
    goFunction(){
      this.$router.push('/functionIntroduce')
    },
    goUserInfo() {
      localStorage.setItem('index', 0)
      if (localStorage.getItem('role')) {
        if (localStorage.getItem('role') === 'ADMIN') {
          this.$router.push('/userReview')
        } else {
          this.$router.push('/userinfo')
        }
      } else {
        this.$message.error('请先登陆')
        setTimeout(() => {
          clearUserInfo()
          this.$router.push('/login')
        }, 1000)
      }
    }
  }
}
</script>
<style scoped>
.header-wrap {
  display: flex;
  justify-content: center;
  text-align: center;
  padding-left: 0.2rem;
  height: 1rem;
}

.el-dropdown-link {
  font-size: 0.2rem;
  margin-bottom: 0.1rem;
}

.btn-wrap {
  display: flex;
  position: absolute;
  right: 0.2rem;
  bottom: 0.2rem;
  cursor: pointer;
}

.el-menu-demo {
  margin-top: 0.16rem;
}

.specil {
  font-size: 0.24rem !important;
}

.user {
  font-size: 0.24rem;
  display: flex;
  align-items: center;
}

.right {
  flex: 1;
  position: relative;
  font-size: 0.24rem;
}

.img-1 {
  display: inline-block;
  height: 0.89rem;
  margin-right: 0.34rem;
  width: 3.01rem;
  cursor: pointer;
  padding-top: 0.09rem;
}

.vip-img {
  width: 0.28rem;
  height: 0.28rem;
  margin-right: 0.03rem;
}

.el-menu-item {
  font-size: 0.24rem;
}

.el-menu {
  padding-top: 0.2rem;
}

.is-active {
  border: 0.01rem dashed #000 !important;
}

.el-dropdown-item {
  font-size: 0.24rem !important;
}

.right-login {
  font-size: 0.24rem;
  margin-right: 0.27rem;
}

.right-reguser {
  font-size: 0.24rem;
}

.menu-item {
  height: 0.42rem !important;
}

.dropdown-item {
  font-size: 0.24rem !important;
  line-height: 0.32rem !important;
}</style>
